<script lang="ts">
    import type {DomainDiff, UpdatedEntity} from "$lib/models/MasterdataDiff";
    import type {OrganizationUnit} from "$lib/models/OrganizationUnit";

    const {organizationUnitDiff, updatedOrganizationUnits}: {
        organizationUnitDiff: DomainDiff<OrganizationUnit> | undefined,
        updatedOrganizationUnits: UpdatedEntity<OrganizationUnit>[]
    } = $props()
</script>

<ul class="ml-1">
  <li>
    <span class="font-bold">New ({organizationUnitDiff?.added.length ?? 0}):</span>
    <br>
    {#each organizationUnitDiff?.added as added (added.id)}
      <div class="pl-1">
        <i>Type:</i> {added.type},
        <i>Name:</i> {added.name}
      </div>
    {/each}
  </li>
  <li>
    <span class="font-bold">Updated ({updatedOrganizationUnits.length}):</span>
    <br>
    {#each updatedOrganizationUnits as organizationUnit (organizationUnit.entity.id)}
      <div class="pl-1">
        <i>Name:</i> {organizationUnit.entity.name}
      </div>
      <ul>
        {#each Object.entries(organizationUnit.changedFields) as [fieldName, changedField] (fieldName)}
          <li>
            <i>{fieldName}:</i> {changedField.newValue} &rarr; {changedField.oldValue}
          </li>
        {/each}
      </ul>
    {/each}
  </li>
  <li>
    <span class="font-bold">Removed ({organizationUnitDiff?.removed.length ?? 0}):</span>
    <br>
    {#each organizationUnitDiff?.removed ?? [] as removed (removed.id)}
      <div class="pl-1">
        <i>Type:</i> {removed.type ?? 'N/A'},
        <i>Name:</i> {removed.name}
      </div>
    {/each}
  </li>
</ul>